/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { SubIvcWaybillVo } from './SubIvcWaybillVo';
import {
    SubIvcWaybillVoFromJSON,
    SubIvcWaybillVoFromJSONTyped,
    SubIvcWaybillVoToJSON,
    SubIvcWaybillVoToJSONTyped,
} from './SubIvcWaybillVo';

/**
 * 
 * @export
 * @interface OrderDetailWarehouseAndServiceVo
 */
export interface OrderDetailWarehouseAndServiceVo {
    /**
     * 订单编号
     * @type {string}
     * @memberof OrderDetailWarehouseAndServiceVo
     */
    orderCode?: string;
    /**
     * 用户名称
     * @type {string}
     * @memberof OrderDetailWarehouseAndServiceVo
     */
    userName?: string;
    /**
     * 用户编码
     * @type {string}
     * @memberof OrderDetailWarehouseAndServiceVo
     */
    userCode?: string;
    /**
     * 订单状态
     * @type {number}
     * @memberof OrderDetailWarehouseAndServiceVo
     */
    orderStatus?: number;
    /**
     * 订单状态名称
     * @type {string}
     * @memberof OrderDetailWarehouseAndServiceVo
     */
    orderStatusName?: string;
    /**
     * 商品状态
     * @type {string}
     * @memberof OrderDetailWarehouseAndServiceVo
     */
    orderWarehouseStatus?: string;
    /**
     * 购买类型
     * @type {number}
     * @memberof OrderDetailWarehouseAndServiceVo
     */
    orderType?: number;
    /**
     * 购买类型名称  代买服务 或 转运服务
     * @type {string}
     * @memberof OrderDetailWarehouseAndServiceVo
     */
    buyTypeName?: string;
    /**
     * 国际运输单号
     * @type {string}
     * @memberof OrderDetailWarehouseAndServiceVo
     */
    ivc?: string;
    /**
     * 运输公司编码
     * @type {string}
     * @memberof OrderDetailWarehouseAndServiceVo
     */
    transportCompanyCode?: string;
    /**
     * 运输公司名称
     * @type {string}
     * @memberof OrderDetailWarehouseAndServiceVo
     */
    transportCompanyName?: string;
    /**
     * 子单号信息列表
     * @type {Array<SubIvcWaybillVo>}
     * @memberof OrderDetailWarehouseAndServiceVo
     */
    subIvcWaybillVOList?: Array<SubIvcWaybillVo>;
    /**
     * 韩国国内运输单号
     * @type {string}
     * @memberof OrderDetailWarehouseAndServiceVo
     */
    krIvc?: string;
    /**
     * 请求类型
     * @type {number}
     * @memberof OrderDetailWarehouseAndServiceVo
     */
    requestType?: number;
    /**
     * 请求类型名称
     * @type {string}
     * @memberof OrderDetailWarehouseAndServiceVo
     */
    requestTypeName?: string;
    /**
     * 仓库名称
     * @type {string}
     * @memberof OrderDetailWarehouseAndServiceVo
     */
    warehouseName?: string;
    /**
     * 跟踪号
     * @type {string}
     * @memberof OrderDetailWarehouseAndServiceVo
     */
    goodsTrackingNumber?: string;
    /**
     * 国际运输方式ID
     * @type {number}
     * @memberof OrderDetailWarehouseAndServiceVo
     */
    internationalTransportMethodId?: number;
    /**
     * 国际运输方式名称
     * @type {string}
     * @memberof OrderDetailWarehouseAndServiceVo
     */
    internationalTransportMethodName?: string;
    /**
     * 支付方式名称
     * @type {string}
     * @memberof OrderDetailWarehouseAndServiceVo
     */
    paymentTypeName?: string;
    /**
     * 仓库要求事项
     * @type {string}
     * @memberof OrderDetailWarehouseAndServiceVo
     */
    requireBeforeAccept?: string;
}

/**
 * Check if a given object implements the OrderDetailWarehouseAndServiceVo interface.
 */
export function instanceOfOrderDetailWarehouseAndServiceVo(value: object): value is OrderDetailWarehouseAndServiceVo {
    return true;
}

export function OrderDetailWarehouseAndServiceVoFromJSON(json: any): OrderDetailWarehouseAndServiceVo {
    return OrderDetailWarehouseAndServiceVoFromJSONTyped(json, false);
}

export function OrderDetailWarehouseAndServiceVoFromJSONTyped(json: any, ignoreDiscriminator: boolean): OrderDetailWarehouseAndServiceVo {
    if (json == null) {
        return json;
    }
    return {
        
        'orderCode': json['orderCode'] == null ? undefined : json['orderCode'],
        'userName': json['userName'] == null ? undefined : json['userName'],
        'userCode': json['userCode'] == null ? undefined : json['userCode'],
        'orderStatus': json['orderStatus'] == null ? undefined : json['orderStatus'],
        'orderStatusName': json['orderStatusName'] == null ? undefined : json['orderStatusName'],
        'orderWarehouseStatus': json['orderWarehouseStatus'] == null ? undefined : json['orderWarehouseStatus'],
        'orderType': json['orderType'] == null ? undefined : json['orderType'],
        'buyTypeName': json['buyTypeName'] == null ? undefined : json['buyTypeName'],
        'ivc': json['ivc'] == null ? undefined : json['ivc'],
        'transportCompanyCode': json['transportCompanyCode'] == null ? undefined : json['transportCompanyCode'],
        'transportCompanyName': json['transportCompanyName'] == null ? undefined : json['transportCompanyName'],
        'subIvcWaybillVOList': json['subIvcWaybillVOList'] == null ? undefined : ((json['subIvcWaybillVOList'] as Array<any>).map(SubIvcWaybillVoFromJSON)),
        'krIvc': json['krIvc'] == null ? undefined : json['krIvc'],
        'requestType': json['requestType'] == null ? undefined : json['requestType'],
        'requestTypeName': json['requestTypeName'] == null ? undefined : json['requestTypeName'],
        'warehouseName': json['warehouseName'] == null ? undefined : json['warehouseName'],
        'goodsTrackingNumber': json['goodsTrackingNumber'] == null ? undefined : json['goodsTrackingNumber'],
        'internationalTransportMethodId': json['internationalTransportMethodId'] == null ? undefined : json['internationalTransportMethodId'],
        'internationalTransportMethodName': json['internationalTransportMethodName'] == null ? undefined : json['internationalTransportMethodName'],
        'paymentTypeName': json['paymentTypeName'] == null ? undefined : json['paymentTypeName'],
        'requireBeforeAccept': json['requireBeforeAccept'] == null ? undefined : json['requireBeforeAccept'],
    };
}

export function OrderDetailWarehouseAndServiceVoToJSON(json: any): OrderDetailWarehouseAndServiceVo {
    return OrderDetailWarehouseAndServiceVoToJSONTyped(json, false);
}

export function OrderDetailWarehouseAndServiceVoToJSONTyped(value?: OrderDetailWarehouseAndServiceVo | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'orderCode': value['orderCode'],
        'userName': value['userName'],
        'userCode': value['userCode'],
        'orderStatus': value['orderStatus'],
        'orderStatusName': value['orderStatusName'],
        'orderWarehouseStatus': value['orderWarehouseStatus'],
        'orderType': value['orderType'],
        'buyTypeName': value['buyTypeName'],
        'ivc': value['ivc'],
        'transportCompanyCode': value['transportCompanyCode'],
        'transportCompanyName': value['transportCompanyName'],
        'subIvcWaybillVOList': value['subIvcWaybillVOList'] == null ? undefined : ((value['subIvcWaybillVOList'] as Array<any>).map(SubIvcWaybillVoToJSON)),
        'krIvc': value['krIvc'],
        'requestType': value['requestType'],
        'requestTypeName': value['requestTypeName'],
        'warehouseName': value['warehouseName'],
        'goodsTrackingNumber': value['goodsTrackingNumber'],
        'internationalTransportMethodId': value['internationalTransportMethodId'],
        'internationalTransportMethodName': value['internationalTransportMethodName'],
        'paymentTypeName': value['paymentTypeName'],
        'requireBeforeAccept': value['requireBeforeAccept'],
    };
}

